
import { DietFoodTypeId, DietFoodType, Params } from 'app/dataTypes/org/dietFoodTypes'
import type { Request } from '../../../index'


type UrlParams = {
  id: number,
}

export const convertParams = ({ orgId }: Params): [null, UrlParams] => {
  return [null, { id: parseInt(orgId, 10) }]
}

type DietFoodItemApi = {
  id: number
  title: string
}

type ApiResult = Array<DietFoodItemApi>

export const convertResult = (apiResult: ApiResult): Array<DietFoodType> => {
  return apiResult.map(item => ({
    id: item.id.toString() as DietFoodTypeId,
    title: item.title,
  }))
}

export const GET_SCHOOL_DIET_FOOD_TYPES: Request<Params, Array<DietFoodType>, void> = [
  'food/schools/{id}/diet_food_types',
  'get',
  ['data', 'diet_food_types'],
]
